import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import get from 'lodash/get';

@Component({
  selector: 'ft-date-group-header',
  templateUrl: './date-group-header.component.html',
  styleUrls: ['./date-group-header.component.scss'],
})
export class DateGroupHeaderComponent {
  headerLabelKey: string;
  asOfDateText: string;
  footnotePlacement: string;

  agInit(params: ICellRendererParams): void {
    this.headerLabelKey = get(params, 'headerLabelKey', null);
    this.footnotePlacement = get(params, 'footnotePlacement', null);
    const asOfDateTextFunc = get(params, 'asOfDateText', null);
    if (asOfDateTextFunc) {
      this.asOfDateText = asOfDateTextFunc();
    }
  }
}
